import React from 'react'
import {Badge, Button, Card, Spin, Typography} from 'antd'
import {useNavigate, useParams} from 'react-router-dom'
import {useQuery} from '@tanstack/react-query'
import {apiUrl} from '../config/api'

export default function Shops() {
    const navigate = useNavigate()
    const {tagId} = useParams()

    const raw = localStorage.getItem('deliveryLocation')
    let deliveryId = null
    if (raw) {
        try {
            const obj = JSON.parse(raw)
            if (obj && typeof obj === 'object') {
                deliveryId = obj.id ?? null
            }
        } catch {
            // ignore parse errors
        }
    }

    const enabled = !!deliveryId && !!tagId

    const {data, isLoading, isError, error, refetch} = useQuery({
        queryKey: ['shops', deliveryId, tagId],
        enabled,
        queryFn: async () => {
            const url = apiUrl(`/api/shops?tagId=${encodeURIComponent(tagId)}&deliveryLocationId=${encodeURIComponent(deliveryId)}`)
            const res = await fetch(url, {headers: {'Accept': 'application/json'}})
            if (!res.ok) {
                throw new Error(`فشل في جلب المتاجر (${res.status})`)
            }
            return res.json()
        }
    })

    const categoryTitle = Array.isArray(data) && data.length > 0 ? data[0].mainCategory?.tagAr : null
    const items = Array.isArray(data) ? data : []

    return (
        <div style={{display: 'grid', gap: 'clamp(12px, 3vw, 20px)'}}>
            {categoryTitle ?
                <Typography.Title level={3} style={{ margin: 0 }}>
                    {categoryTitle} <Button onClick={() => navigate('/categories')}>عودة</Button>
                </Typography.Title>
            : <div><Button onClick={() => navigate('/categories')}>عودة</Button></div>}

            {!enabled && (
                <Card>
                    <Typography.Paragraph style={{margin: 0}}>
                        بيانات غير مكتملة لعرض المتاجر.
                    </Typography.Paragraph>
                </Card>
            )}

            {enabled && isLoading && (
                <div style={{display: 'flex', justifyContent: 'center', padding: '16px 0'}}>
                    <Spin/>
                </div>
            )}

            {enabled && isError && (
                <Card>
                    <Typography.Text type="danger" style={{marginBottom: 12, display: 'block'}}>
                        حدث خطأ أثناء جلب المتاجر: {error?.message || 'خطأ غير معروف'}
                    </Typography.Text>
                    <Button onClick={() => refetch()}>إعادة المحاولة</Button>
                </Card>
            )}

            {enabled && !isLoading && !isError && items.length === 0 && (
                <Card>
                    <Typography.Paragraph style={{margin: 0}}>
                        لا توجد متاجر متاحة حالياً.
                    </Typography.Paragraph>
                </Card>
            )}

            {enabled && !isLoading && !isError && items.length > 0 && (
                <div
                    style={{
                        display: 'grid',
                        gap: 'clamp(12px, 3vw, 20px)',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(132px, 1fr))',
                        alignItems: 'stretch'
                    }}
                >
                    {items.map((shop) => {
                        const title = shop.nameAr
                        const img = `https://images.leen-go.com/${shop.imageUrl || 'no-image.png'}`
                        const isClosed = shop?.isOpened === false
                        const showIds = typeof localStorage !== 'undefined' && localStorage.getItem('showIds') === 'true'
                        const card = (
                            <Card
                                style={{
                                    padding: 10,
                                    border: '1px solid #cccccc',
                                    boxShadow: '3px 2px 3px #cccccc',
                                    height: '100%',
                                    filter: isClosed ? 'grayscale(100%)' : undefined,
                                    opacity: isClosed ? 0.7 : 1,
                                    cursor: isClosed ? 'default' : 'pointer',
                                }}
                                hoverable={!isClosed}
                                onClick={() => { if (!isClosed) navigate(`/shop-priced-items/${shop.id}`) }}
                                cover={
                                    <div style={{width: '100%', aspectRatio: '1 / 1', overflow: 'hidden', background: '#fafafa'}}>
                                        <img
                                            src={img}
                                            alt={title}
                                            style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}}
                                            loading="lazy"
                                            onError={(e) => {
                                                if (e.currentTarget.src.endsWith('/no-image.png')) return
                                                e.currentTarget.src = '/no-image.png'
                                            }}
                                        />
                                    </div>
                                }
                            >
                                <div style={{ textAlign: 'center' }}>
                                    {showIds && shop?.id != null && (
                                        <span style={{ display: 'inline-block', fontSize: 16, fontWeight: 'bold', fontFamily: 'monospace', background: '#f0f0f0', color: '#666', padding: '2px 6px', borderRadius: 4, marginBottom: 4 }}>
                                            #{shop.id}
                                        </span>
                                    )}
                                </div>
                                <Typography.Paragraph
                                    title={title}
                                    style={{marginBottom: 0, whiteSpace: 'normal', wordBreak: 'break-word'}}
                                >
                                    {title}
                                </Typography.Paragraph>
                            </Card>
                        )
                        return isClosed ? (
                            <Badge.Ribbon text="مغلق" color="red" key={shop.id || title}>
                                {card}
                            </Badge.Ribbon>
                        ) : (
                            <React.Fragment key={shop.id || title}>{card}</React.Fragment>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
